import { getCleengScriptUrl } from './config';
import type { LookupResponse } from './api';

declare global {
  interface Window {
    cleeng?: {
      setAuthTokens: (tokens: { jwt: string; refreshToken: string }) => void;
    };
  }
}

export const loadCleengScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.cleeng) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = getCleengScriptUrl();
    script.async = true;

    const timeout = setTimeout(() => {
      reject(new Error('Cleeng script laadtijd overschreden'));
    }, 10000);

    script.onload = () => {
      clearTimeout(timeout);
      // Wait for cleeng object to be available
      const checkCleeng = () => {
        if (window.cleeng) {
          resolve();
        } else {
          setTimeout(checkCleeng, 100);
        }
      };
      checkCleeng();
    };

    script.onerror = () => {
      clearTimeout(timeout);
      reject(new Error('Cleeng script laden mislukt'));
    };

    document.head.appendChild(script);
  });
};

export const initializeCleengWidget = (data: LookupResponse): void => {
  if (!window.cleeng) {
    throw new Error('Cleeng niet geladen');
  }

  window.cleeng.setAuthTokens({
    jwt: data.jwt,
    refreshToken: data.refreshToken,
  });

  const container = document.getElementById('cleeng-widget');
  if (!container) {
    throw new Error('Widget container niet gevonden');
  }

  container.innerHTML = `
    <div 
      data-cleeng-widget="checkout"
      data-cleeng-publisher-id="${data.publisherId}"
      data-cleeng-offer-id="${data.offerId}"
      data-cleeng-language="nl-NL">
    </div>
  `;
};